import { LinearGradientContainer } from '../LinearGradient'
import { FooterView } from './FooterView'

interface Props {
  type?: 'consumer' | 'business'
}
const Footer = ({ type = 'business' }: Props) => {
  if (type === 'consumer') {
    return (
      <LinearGradientContainer useAngle={true} angle={287} colorArray={['#000092', '#1634A0']}>
        <FooterView type={type} />
      </LinearGradientContainer>
    )
  }
  return <FooterView type={type} />
}

export default Footer
